import { store, canUseLeave } from '@/stores/store';
export default {
  name: "HeaderUser",
  data() {
    return {
      store
    };
  },
  methods: {
    canUseLeave
  }
};